import { useRef, useState } from "react";
import { IAvailableEndpoint } from "../../interfaces/endpoints/IMcpTool";

interface Props {
  endpoints: IAvailableEndpoint[];
  onSelect: (ep: IAvailableEndpoint) => void;
}

const badgeClass = (m: string) => {
  if (m === "GET") return "bg-green-100 text-green-800";
  if (m === "POST") return "bg-blue-100 text-blue-800";
  return "bg-yellow-100 text-yellow-800";
};

const EndpointDropdown: React.FC<Props> = ({
  endpoints,
  onSelect
}) => {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const filtered = query
    ? endpoints.filter(
        (ep) =>
          ep.endpoint.toLowerCase().includes(query.toLowerCase())
          || ep.groupName.toLowerCase().includes(query.toLowerCase())
      )
    : endpoints;

  const select = (ep: IAvailableEndpoint) => {
    setQuery(ep.endpoint);
    setOpen(false);
    onSelect(ep);
  };

  return (
    <div className="relative" ref={ref}>
      <label className="block text-sm font-medium mb-1">
        Endpoint
      </label>
      <input
        type="text"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 200)}
        placeholder="Search endpoints..."
        className="w-full border rounded-md px-3 py-2 text-sm font-mono"
        required
      />
      {open && filtered.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border
          rounded-md shadow-lg max-h-60 overflow-y-auto"
        >
          {filtered.map((ep, idx) => (
            <button
              key={idx}
              type="button"
              className="w-full text-left px-3 py-2
                hover:bg-gray-50 flex items-center gap-2
                border-b last:border-b-0"
              onMouseDown={() => select(ep)}
            >
              <span className={`px-1.5 py-0.5 rounded text-xs
                font-medium shrink-0 ${badgeClass(ep.method)}`}
              >
                {ep.method}
              </span>
              <span className="text-sm font-mono truncate">
                {ep.endpoint}
              </span>
              <span className="text-xs text-gray-400 shrink-0 ml-auto">
                {ep.groupName}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EndpointDropdown;
